var headroom;

// Load background images
jQuery(".load-bg-img").each(function (i, obj) {
  var large_img = jQuery(this).attr("data-bg-large");
  var small_img = jQuery(this).attr("data-bg-small");

  var item = jQuery(this);

  var bgImg = new Image();
  bgImg.onload = function () {
    item.css("background-image", "url(" + bgImg.src + ")");
    item.addClass("loaded");
  };

  if (jQuery(document).width() > 800) {
    bgImg.src = item.attr("data-bg");
  } else if (jQuery(document).width() > 400) {
    bgImg.src = item.attr("data-bg-small");
  } else {
    bgImg.src = item.attr("data-bg-tiny");
  }
});

// Navigation
jQuery(".dropdown").on("show.bs.dropdown", function () {
  var elem = jQuery(this).find(".dropdown-menu");
  setTimeout(function () {
    elem.addClass("inplace");
  }, 100);
});
jQuery(".dropdown").on("hide.bs.dropdown", function () {
  jQuery(this).find(".dropdown-menu").removeClass("inplace");
});
// Back button for the main menu
jQuery("#menu-primary-navigation .dropdown").on(
  "hide.bs.dropdown",
  function () {
    jQuery(".subnavbar-toggler").removeClass("show");
    setTimeout(function () {
      jQuery(".subnavbar-toggler").removeClass("inplace");
    }, 200);
  }
);
jQuery("#menu-primary-navigation .dropdown").on(
  "show.bs.dropdown",
  function () {
    jQuery(".subnavbar-toggler").addClass("inplace");
    setTimeout(function () {
      jQuery(".subnavbar-toggler").addClass("show");
    }, 200);
  }
);
jQuery(document).ready(function () {
  jQuery(document).on("click", ".dropdown-menu", function (e) {
    e.stopPropagation();
  });
});

current_employee = "";

// Bio popups
jQuery(document).ready(function () {
  jQuery(".modal-trigger").on("click", function () {
    var id = jQuery(this).attr("id");
    console.log(jQuery("#" + id + "-content .mtitle").html());
    //jQuery('#' + id + ' .mtitle').html();
    jQuery(".modal .modal-title").html(
      jQuery("#" + id + "-content .mtitle").html()
    );
    jQuery(".modal .modal-body").html(
      jQuery("#" + id + "-content .mbody").html()
    );

    jQuery(".modal").modal("show");
  });
});

jQuery(document).ready(function () {
  jQuery(".answer.collapse").on("hide.bs.collapse", function () {
    jQuery(this).parent().find("h3").removeClass("showing");
  });

  jQuery(".answer.collapse").on("show.bs.collapse	", function () {
    jQuery(this).parent().find("h3").addClass("showing");
  });

  jQuery(".nav.collapse").on("hide.bs.collapse", function () {
    jQuery(".navbar-container").removeClass("show");
    jQuery(".navbar-toggler").removeClass("show");
    jQuery("html").removeClass("show-nav");
    jQuery("body").removeClass("no-scroll");
    setTimeout(function () {
      jQuery(".navbar-container").removeClass("showing");
      jQuery(".navbar-toggler").removeClass("showing");
      jQuery("html").removeClass("showing-nav");
    }, 100);
  });

  jQuery(".nav.collapse").on("show.bs.collapse	", function () {
    jQuery(".navbar-container").addClass("showing");
    jQuery(".navbar-toggler").addClass("showing");
    jQuery("html").addClass("showing-nav");
    jQuery("body").addClass("no-scroll");

    setTimeout(function () {
      jQuery(".navbar-container").addClass("show");
      jQuery(".navbar-toggler").addClass("show");
      jQuery("html").addClass("show-nav");
    }, 100);
  });

  jQuery(".the-search-form.collapse").on("show.bs.collapse	", function () {
    setTimeout(function () {
      jQuery(".the-search-form input.search-field").focus();
      //console.log("Here");
    }, 300);
  });
});

var heroTween = new TimelineMax({ paused: true });
// If we have a hero
if (jQuery(".page-title").length) {
  if (jQuery(".page-title").hasClass("no-img")) {
  } else {
    var bgImg = new Image();
    bgImg.onload = function () {
      jQuery(".page-title").css("background-image", "url(" + bgImg.src + ")");

      setTimeout(function () {
        jQuery(".page-title").addClass("inplace");
      }, 20);
    };

    if (jQuery(document).width() > 800) {
      bgImg.src = jQuery(".page-title").attr("data-bg");
    } else if (jQuery(document).width() > 400) {
      bgImg.src = jQuery(".page-title").attr("data-bg-small");
    } else {
      bgImg.src = jQuery(".page-title").attr("data-bg-tiny");
    }
  }
}
/*
jQuery(".page-title").imagesLoaded(function () {
  // Animate it for coolness
  jQuery(document).ready(function () {
    // Hero fade in
    var h1 = jQuery(".page-title h1");
    var heroTween = new TimelineMax();

    heroTween
      .fromTo(h1, 0.6, { opacity: 0 }, { delay: 0.3, opacity: 1 })
      .play();
    setTimeout(function () {
      jQuery(".page-title").addClass("inplace");
    }, 200);
  });
});
*/

jQuery(".f_product_single .thumb").imagesLoaded(function () {
  setTimeout(function () {
    jQuery(".f_product_single .thumb").addClass("inplace");
  }, 100);
});

/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    common: {
      init: function () {
        jQuery(
          ".marry-widows h1, .marry-widows h2, .marry-widows h3, .marry-widows p"
        ).each(function () {
          var string = jQuery(this).html();
          string = string.replace(/ ([^ ]*)$/, "&nbsp;$1");
          jQuery(this).html(string);
        });

        var viewport_width = jQuery(document).width();
        var offset = 40;
        if (viewport_width < 1000) {
          offset = 40;
        }

        var myElement = document.querySelector("header");
        // construct an instance of Headroom, passing the element
        headroom = new Headroom(myElement, {
          offset: offset,
          tolerance: {
            down: 11,
            up: 3,
          },
          // callback when pinned, `this` is headroom object
          onPin: function () {
            jQuery("html").addClass("hr--pinned");
          },
          // callback when unpinned, `this` is headroom object
          onUnpin: function () {
            jQuery("html").removeClass("hr--pinned");
          },
        });
        // initialise
        headroom.init();

        // Secondary navigation
        /*
          var secondary_nav = document.querySelector(".secondary-nav nav");
          // construct an instance of Headroom, passing the element
          var headroom_secondary = new Headroom(secondary_nav, {
            offset: 100,
            tolerance: {
              down: 11,
              up: 3
            }
          });
          // initialise
          headroom_secondary.init();
          */
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },
    // Home page
    home: {
      init: function () {
        // JavaScript to be fired on the home page
      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      },
    },
    // About us page, note the change from about-us to about_us.
    about_us: {
      init: function () {
        // JavaScript to be fired on the about us page
      },
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = funcname === undefined ? "init" : funcname;
      fire = func !== "";
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === "function";

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire("common");

      // Fire page-specific init JS, and then finalize JS
      $.each(
        document.body.className.replace(/-/g, "_").split(/\s+/),
        function (i, classnm) {
          UTIL.fire(classnm);
          UTIL.fire(classnm, "finalize");
        }
      );

      // Fire common finalize JS
      UTIL.fire("common", "finalize");
    },
  };

  // Load Events
  jQuery(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.

function getScrollTop() {
  if (typeof pageYOffset !== "undefined") {
    //most browsers except IE before #9
    return pageYOffset;
  } else {
    var B = document.body; //IE 'quirks'
    var D = document.documentElement; //IE with doctype
    D = D.clientHeight ? D : B;
    return D.scrollTop;
  }
}

function getHeaderTop(div) {
  var winTop;
  if (!div) {
    winTop = jQuery(window).scrollTop();
  } else {
    winTop = jQuery(div).offset().top;
  }
  var headerTop = winTop;
  if (headerTop > headerHidden) {
    headerTop = headerHidden;
  } else if (headerTop < 0) {
    headerTop = 0;
  }
  return headerTop;
}

// State of the header.
var top_stick = true;
var darker_nav = false;
var promo_in_place = false;
var product_nav_from_top = 0;
var product_nav_stuck = false;

// Update the navigation based on the width of the viewport.
function updateNav() {
  //
  // Update header background color.
  //
  var from_top = jQuery(window).scrollTop();
  if (from_top > 10 && !darker_nav) {
    jQuery(".header").addClass("scrollnav");
    darker_nav = true;
  } else if (from_top <= 10 && darker_nav) {
    jQuery(".header").removeClass("scrollnav");
    darker_nav = false;
  }

  if (product_nav_from_top > 0) {
    if (!product_nav_stuck && from_top >= product_nav_from_top) {
      jQuery(".product-nav-container").addClass("nav--pinned");
      product_nav_stuck = true;
    } else if (product_nav_stuck && from_top < product_nav_from_top) {
      jQuery(".product-nav-container").removeClass("nav--pinned");
      product_nav_stuck = false;
    }
  }
}

function windowResizeTasks() {
  if (jQuery(".product-nav-container").length > 0) {
    product_nav_from_top = jQuery(".product-nav-container").offset().top;
  }
}

jQuery(document).ready(function () {
  jQuery("html").addClass("js");

  windowResizeTasks();

  updateNav();
  jQuery(window).scroll(jQuery.throttle(65, updateNav));
  jQuery(window).on("debouncedresize", function (event) {
    // Your event handler code goes here.
    updateNav();
  });
});

/* ================================
 * Map locations
 * ============================= */
jQuery(document).ready(function () {
  jQuery(document).on("facetwp-loaded", function () {
    if ("" == FWP.buildQueryString()) {
      jQuery(".reset-button").addClass("disabled");
      jQuery(".reset-button").attr("disabled", "disabled");
    } else {
      jQuery(".reset-button").removeClass("disabled");
      jQuery(".reset-button").removeAttr("disabled", "disabled");
    }

    // Product page doc view
    if (jQuery(".single-f_products").length > 0) {
      // Get active filters
      var active_filters = 0;

      Object.keys(FWP.facets).forEach(function (key, index) {
        // key: the name of the object key
        // index: the ordinal position of the key within the object
        if (FWP.facets[key].length > 0) active_filters++;
      });

      // If we're on a product page and there are no facets select, blank out the results.
      if (active_filters == 0 && 0) {
        jQuery(".facetwp-template").html(
          "<div class='select-cat'>Select a category to view documents</div>"
        );
        jQuery(".view-more-posts").addClass("disabled");
      } else {
        jQuery(".view-more-posts").removeClass("disabled");
      }
    }

    // Expand the selected documetn type.
    if (FWP.facets.document_types !== undefined) {
      jQuery(".facetwp-facet-document_types > .facetwp-checkbox.checked").each(
        function () {
          var facet_val = jQuery(this).attr("data-value");
          jQuery('.facetwp-checkbox[data-value="' + facet_val + '"]')
            .next(".facetwp-depth")
            .addClass("visible");
        }
      );
      /*
      Object.keys(FWP.facets.document_types).forEach(function (key, index) {
        var facet_val = FWP.facets.document_types[key];
        console.log('.facetwp-checkbox[data-value="' + facet_val + '"]');
        jQuery('.facetwp-checkbox[data-value="' + facet_val + '"]').next('.facetwp-depth').addClass('visible');
      });
      */
    }

    // If there is an export button let's set the URL.
    if (jQuery("#export-products-link").length > 0) {
      url = new URL(window.location.href);
      url.searchParams.set("export_product_csv", 1);
      // Set the export URL
      jQuery("#export-products-link").attr("href", url.toString());
      // Set he number of results
      var total_rows = "(" + FWP.settings.pager["total_rows"] + ")";
      jQuery("#export-products-link").html("Export CSV " + total_rows);
    }

    // Add to cart buttons in the loop, allow them to have quantity input
    // Whenever one of these inputs updates, increment the data-quantity attribute for the add to cart link/button
    jQuery(".products-col input.qty").on("change", function () {
      var button = jQuery(this).closest("li.product").find("a.button");
      var qty = button.attr("data-quantity");
      qty++;
      button.attr("data-quantity", jQuery(this).val());
    });
  });

  jQuery(document).on("facetwp-refresh", function () {
    jQuery(".fwp-elements").addClass("loading");
    //console.log('Refresh');
    //console.log(FWP);
  });

  jQuery(document).on("facetwp-loaded", function () {
    jQuery(".fwp-elements").removeClass("loading");
    //console.log('Loaded');
    //console.log(FWP);
  });
});

jQuery(document).ready(function () {
  jQuery(document).on("facetwp-refresh", function () {
    jQuery(".facetwp-template").addClass("loading");
  });

  jQuery(document).on("facetwp-loaded", function () {
    jQuery(".facetwp-template").removeClass("loading");
  });
});

function createCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + value + expires + "; path=/";
}

function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
}

function eraseCookie(name) {
  createCookie(name, "", -1);
}

/* ================================
 * Cookie notice
 * ============================= */
jQuery(document).ready(function () {
  var allow_cookies = readCookie("allow_cookies");
  if (allow_cookies !== "yes") {
    jQuery(".cookie-notice").addClass("display");
    jQuery(".cookie-notice").addClass("inplace");
  } else {
    console.log("Cookies allowed.");
  }

  jQuery("#allow-cookies").click(function (event) {
    createCookie("allow_cookies", "yes", 7);

    setTimeout(function () {
      jQuery(".cookie-notice").removeClass("display");
    }, 200);
    jQuery(".cookie-notice").removeClass("inplace");

    return false;
  });
});

// Tooltips
jQuery(document).ready(function () {
  jQuery(function () {
    //jQuery('[data-toggle="tooltip"]').tooltip();

    var tooltip_triggers = "hover focus";
    //jQuery(document).width() >= 1000

    // If this browser has touch events.
    if (Modernizr.touchevents) {
      tooltip_triggers = "click focus";
    }

    jQuery(".cutaway .trigger").tooltip({
      placement: "top",
      trigger: tooltip_triggers,
    });

    //.cutaway .trigger

    // Application tooltips
    jQuery(".app-icon").tooltip({
      placement: "top",
      trigger: tooltip_triggers,
    });
  });
});

jQuery(document).ready(function () {
  // Add smooth scrolling to all links
  jQuery(".product-nav a, .doc-nav a").on("click", function (event) {
    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "") {
      // Prevent default anchor click behavior
      event.preventDefault();

      // Store hash
      var hash = this.hash;

      //window.location = window.location.href.split('#')[0];

      //console.log(hash);

      // If it's a "docs-" hash then
      if (hash.indexOf("docs--") > 0) {
        jQuery(".fwp-elements").addClass("loading");
        jQuery(".facetwp-facet").addClass("is-loading");

        // Find the cat slug and open it
        var pieces = hash.split("--");

        // split more?
        var cats = pieces[1].split("+");

        console.log("Before:");
        console.log(FWP);

        // Update the facet.
        //FWP.facets.document_types = [pieces[1]];
        FWP.facets["document_types"] = cats;
        FWP.fetchData();

        //FWP.setHash();
        //FWP.fetchData();
        //FWP.parseFacets();
        //FWP.refresh();

        //FWP.reset({ 'document_types': cats });

        console.log("After:");
        console.log(FWP);

        var hash_docs = "#docs";
        jQuery("html, body").animate(
          {
            scrollTop: jQuery(hash_docs).offset().top,
          },
          800,
          function () {
            // Add hash (#) to URL when done scrolling (default click behavior)
            //window.location.hash = hash_docs;

            // Close main nav.
            headroom.unpin();
          }
        );
      } else {
        // Using jQuery's animate() method to add smooth page scroll
        // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
        jQuery("html, body").animate(
          {
            scrollTop: jQuery(hash).offset().top,
          },
          800,
          function () {
            // Add hash (#) to URL when done scrolling (default click behavior)
            window.location.hash = hash;
            // Close main nav.
            headroom.unpin();
          }
        );
      }
    } // End if
  });
});

jQuery(document).ready(function () {
  jQuery(".popover-info").popover();

  jQuery(document).on("facetwp-loaded", function () {
    // Document categories.
    jQuery(".popover-data-cats").popover({
      trigger: "hover",
    });
  });
});

// Initiate dropdown additional files
jQuery(document).ready(function () {
  jQuery(document).on("facetwp-loaded", function () {
    jQuery(".document.multiple-types").each(function () {
      jQuery(this)
        .find(".af-toggle")
        .on("click", function () {
          // Toggle this additional files block
          var this_id = jQuery(this).attr("data-doc-id");
          jQuery("#af-" + this_id).toggle();
          return false;
        });
    });
  });
});

// Add labels to the 2 sizing sliders
jQuery(document).on("facetwp-loaded", function () {
  jQuery(document).ready(function () {
    //console.log(FWP.facets.document_types);

    jQuery(".facetwp-facet").each(function () {
      var $facet = jQuery(this);
      var facet_name = $facet.attr("data-name");
      var facet_label = FWP.settings.labels[facet_name];

      if (facet_name == "product_size" || facet_name == "product_size_btu_hr") {
        if (
          $facet.closest(".facet-wrap").length < 1 &&
          $facet.closest(".facetwp-flyout").length < 1
        ) {
          if ($facet.find(".facetwp-slider").children().length > 0) {
            $facet.wrap('<div class="facet-wrap"></div>');
            $facet.before('<h3 class="facet-label">' + facet_label + "</h3>");
          }
        }
      }
    });
  });
});

jQuery(document).ready(function () {
  jQuery(".rep-year").on("change", function () {
    jQuery(this).parent("form").submit();
  });
});

// Add info icons to the documents categories
/*
jQuery(document).ready(function() {
  jQuery(document).on('facetwp-loaded', function () {





    jQuery('.facetwp-facet').each(function () {
      var $facet = jQuery(this);
      var facet_name = $facet.attr('data-name');

      if (facet_name == 'product_size' || facet_name == 'product_size_btu_hr') {
        if ($facet.closest('.facet-wrap').length < 1 && $facet.closest('.facetwp-flyout').length < 1) {
          if ($facet.find('.facetwp-slider').children().length > 0) {
            $facet.wrap('<div class="facet-wrap"></div>');
            $facet.before('<h3 class="facet-label">' + facet_label + '</h3>');
          }
        }
      }


    });
    





  });
});
*/

jQuery(document).ready(function () {
  add_sort_handlers();
  jQuery(document).on("facetwp-loaded", function () {
    add_sort_handlers();

    if (FWP.extras.sort != "default") {
      var sort = FWP.extras.sort;

      var sort_details = sort.split("_");
      if (jQuery("#sort-" + sort_details[0]).length > 0) {
        var new_direction = "";
        if (sort_details[1] == "desc") {
          new_direction = "asc";
        } else {
          new_direction = "desc";
        }

        // Remove sorting class from all headers.
        jQuery(".doc-sort").removeClass("asc");
        jQuery(".doc-sort").removeClass("desc");

        // Add sorting style to the appropriate header.
        jQuery("#sort-" + sort_details[0]).addClass(new_direction);

        //console.log('Updated sorting:' + sort_details[0]);

        jQuery("#sort-" + sort_details[0]).attr(
          "data-direction",
          new_direction
        );
      }
    } else {
      // Remove sorting class from all headers.
      jQuery(".doc-sort").removeClass("asc");
      jQuery(".doc-sort").removeClass("desc");
      //jQuery('#sort-modified').addClass('desc');
    }
  });
});

function add_sort_handlers() {
  //console.log('Loading sort stuff.');
  // Remove any events on the sort links.
  jQuery("a.doc-sort").off();
  jQuery("a.doc-sort").on("click", function () {
    var data_sort = jQuery(this).attr("data-sort");
    var data_direction = jQuery(this).attr("data-direction");

    FWP.extras.sort = data_sort + "_" + data_direction;
    FWP.soft_refresh = true;
    //FWP.refresh();
    FWP.autoload();

    return false;
  });
}

// Prevent all tabs from being hidden at once.
jQuery(document).ready(function () {
  // the current open accordion will not be able to close itself
  jQuery('.accordion button[data-toggle="collapse"]').on("click", function (e) {
    if (!jQuery(this).hasClass("collapsed")) {
      e.stopPropagation();
    }
  });
});

// When the shipping method changes, check to see if it's collect so we
// can make the collect method dropdown available.
jQuery(document).ready(function () {
  jQuery(document.body).on("updated_checkout", function (e) {
    fulton_checkout_collect_check();
  });

  /*
  jQuery(document.body).on('change', 'input.shipping_method', function () {

    if (jQuery('input.shipping_method').val() == 'flat_rate:1') { 
      jQuery('.collect-shipping-info').css('display', 'block');

      console.log('MADE VISIBLE: ' + jQuery('input.shipping_method').val());
    }
  });
  */
});



function fulton_checkout_collect_check() {
  if (
    jQuery('input[type="hidden"][name="shipping_method[0]"]').val() ==
      "fulton_collect:6" ||
    jQuery('input[type="hidden"][name="shipping_method[0]"]').val() ==
      "fulton_collect:3" ||
    jQuery(
      "#shipping_method_0_fulton_collect6, #shipping_method_0_fulton_collect3"
    ).is(":checked")
  ) {
    // Also check the county
    var country = jQuery("#shipping_country").val();
    if (country == "CA") {
      jQuery(".collect-shipping-info-ca").css("display", "table-row");
      jQuery(".collect-shipping-info-us").css("display", "none");
    } else if (country == "US") {
      jQuery(".collect-shipping-info-us").css("display", "table-row");
      jQuery(".collect-shipping-info-ca").css("display", "none");
    } else {
      jQuery(".collect-shipping-info-ca").css("display", "none");
      jQuery(".collect-shipping-info-us").css("display", "none");
    }
  } else {
    jQuery(".collect-shipping-info-ca").css("display", "none");
    jQuery(".collect-shipping-info-us").css("display", "none");
  }
}





// Show on map pin
jQuery(document).ready(function () {
  jQuery(document).on("facetwp-loaded", function () {
    if (window.FWP_MAP !== undefined) {
      jQuery(".view-on-map").on("click", function (e) {
        var post_id = jQuery(this).attr("data-location-id");
        if (
          FWP_MAP.markerLookup[post_id] !== null &&
          FWP_MAP.markerLookup[post_id] !== undefined
        ) {
          //var postid = jQuery(this).attr("data-id");
          console.log('This post id ' + post_id);
          var marker = FWP_MAP.get_post_markers(post_id);
          jQuery.each(marker, function (key, value) {
            FWP_MAP.map.setCenter({
              lat: value.position.lat(),
              lng: value.position.lng(),
            });
            FWP_MAP.is_zooming = true; // Needed if you are using the "Enable map filtering" button
            FWP_MAP.map.setZoom(13); // Set a zoom level between 1 and 20. Make sure it is higher than the marker clusterer's bottom limit.

            // google.maps.event.trigger(value, 'click'); // If you don't have spiderfied markers
            google.maps.event.trigger(value, "spider_click"); // If you have spiderfied markers. Will also work if you don't have spiderfied markers.
          });

            var hash = '#companies-map';

            jQuery("html, body").animate(
              {
                scrollTop: jQuery(hash).offset().top - 40
              },
              800,
              function () {
                // Add hash (#) to URL when done scrolling (default click behavior)
                //window.location.hash = hash;
                // Close main nav.
                
                setTimeout(function () {
                  headroom.unpin();
                }, 200);
              }
            );
        }
        return false;
      });
    }
  });
});



// Product switching for showing inventory modal (stock inventory page)
jQuery(document).ready(function () {
  jQuery('#inventory_product_id').on('change', function () {
      jQuery('#product-inventory-modal-' + jQuery(this).val()).modal('toggle');
  });
});
